import React, { useEffect, useState } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import { DropdownButton, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaRegUserCircle } from "react-icons/fa";
import "./../../assets/sass/style.css";
import userImgAvator from "./../../assets/img/user.png";
import { useSelector } from "react-redux";
import { API_SRC } from "../../commons/Constants";
import { useDispatch } from "react-redux";
import { logoutAuth } from "../../features/setting/userSlice";
import { useNavigate } from "react-router-dom";
function Sidedropdown({ invitations }) {
  // const invitation = useSelector((state) => state.invitation.value);
  // console.log("reducer", invitation);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sidebars = JSON.parse(localStorage.getItem("user"));

  const username = sidebars?.user.name;
  const userImg = sidebars?.user.profile_img_url;

  const [value, setValue] = useState("");
  const [invitataionCount, setInvitationCount] = useState(0);

  const handleSelect = (e) => {
    console.log(e);
    setValue(e);
  };

  useEffect(() => {
    setInvitationCount(localStorage.getItem("invitation"));
  }, []);

  const handleLogout = () => {
    dispatch(logoutAuth())
      .unwrap()
      .then(() => {
        localStorage.removeItem('redirectAfterLogin');
        navigate('/');
      })
      .catch((error) => {
        console.error("Logout failed: ", error);
      });
  };

  return (
    <div className='App container'>
      <Dropdown onSelect={handleSelect}>
        <img src={userImg ?  `${API_SRC}/${userImg}` : userImgAvator} alt='' />
        <Dropdown.Toggle variant='custom' style={{ color: "white" }} className='bottom--profile' id='dropdownMenuButton1'>
          {/* <FaRegUserCircle/>  */}

          <span className='user_name'> {username}</span>
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item as={Link} to='/invitation'>Invitations {invitataionCount ? <span className='invitationCircle'>{invitataionCount}</span> : ""}</Dropdown.Item>
          <Dropdown.Item as={Link} to='/profile'>Profile</Dropdown.Item>
          <Dropdown.Item href='#'>Settings</Dropdown.Item>
          <Dropdown.Item
          onClick={handleLogout}>
            <Link  className="text-danger">Logout</Link>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}

export default Sidedropdown;
